import { useSelector } from 'react-redux'
import {
  selectUserType,
  selectAthurised,
} from '../redux/selectors/authSelector'
import { ROUTES } from './routes'

const useAppRoutes = () => {
  // Use useSelector to access the authorised and userType from the Redux store
  const userType = useSelector(selectUserType)
  const authorised = useSelector(selectAthurised)

  const securedRoute = Object.keys(ROUTES).map((key) => {
    const route = ROUTES[key]
    if (!route.isSecured) return { ...route }
    return { ...route }
  })

  // Function to filter the object based on UserType
  function filterObjectByUserType(obj) {
    const filteredObj = {}
    Object.keys(obj).forEach((key) => {
      if (obj[key].UserType === true) {
        filteredObj[key] = obj[key]
      }
    })

    return filteredObj
  }

  const filteredUserRoute = filterObjectByUserType(ROUTES)

  const securedUserRoute = Object.keys(filteredUserRoute).map((key) => {
    const route = ROUTES[key]
    return { ...route }
  })

  function filterUnAthorizedRoutes(obj) {
    const filteredObj = {}
    Object.keys(obj).forEach((key) => {
      if (obj[key].isSecured !== true) {
        filteredObj[key] = obj[key]
      }
    })
    return filteredObj
  }

  const UnAuthorisedRoute = filterUnAthorizedRoutes(ROUTES)

  // Treat 'internal' users as secured (same as admin/sub_admin)
  if ((['admin', 'sub_admin', 'internal'].includes(userType)) && authorised) {
    return securedRoute
  } else if (userType === 'client' && authorised) {
    return securedUserRoute
  } else if (userType === 'investor' && authorised) {
    return securedUserRoute
  } else {
    return UnAuthorisedRoute
  }
}
export default useAppRoutes
